import { getLabelOptions, getMultiTermText } from '../../../utils/commonUtils';

export const featureTableHeaderData = [
    {
        _key: 'id',
        label: getMultiTermText({ id: '99008287', text: 'ID#' }),
        searching: true,
        sorting: true,
        width: '5%',
        isEditable: false,
        columnDataClassName: 'Font_bold'
    },
    {
        _key: 'description',
        label: getMultiTermText({ id: '99018122', text: 'Name' }),
        searching: true,
        sorting: true,
        width: '20%',
        isEditable: true
    },
    {
        _key: 'name',
        label: getMultiTermText({ id: '99002657', text: 'Short name' }),
        searching: true,
        sorting: true,
        width: '25%',
        isEditable: true
    },
    {
        _key: 'sapId',
        label: getMultiTermText({ id: '99031088', text: 'SAP ID' }),
        searching: true,
        sorting: true,
        width: '20%',
        isEditable: true
    },
    {
        _key: 'status',
        label: getMultiTermText({ id: '3000144', text: 'Status' }),
        searching: false,
        sorting: true,
        width: '10%',
        isEditable: true,
        _component: 'label',
        filterOptions: [
            {
                id: 1,
                name: getMultiTermText({ id: '99000784', text: 'Enabled' })
            },
            {
                id: 2,
                name: getMultiTermText({ id: '99000809', text: 'Disabled' })
            }
        ],
        labelOptions: [
            {
                id: 1,
                text: getLabelOptions({ id: '99000784', text: 'Enabled', className: 'Status_green' })
            },
            {
                id: 2,
                text: getLabelOptions({ id: '99000809', text: 'Disabled', className: 'Status_gray' })
            }
        ]
    },
    {
        _key: 'dependentOn',
        label: getMultiTermText({ id: '99032433', text: 'Dependent on feature(s)' }),
        searching: true,
        sorting: true,
        width: '20%',
        isEditable: false
    }
];

export const associatedProductsHeaderData = [
    {
        _key: 'productId',
        label: getMultiTermText({ id: '99011330', text: 'Product ID' }),
        searching: true,
        sorting: true,
        width: '20%',
        isEditable: false,
        columnDataClassName: 'Font_bold'
    },
    {
        _key: 'productName',
        label: getMultiTermText({ id: '99029998', text: 'Product name' }),
        searching: true,
        sorting: true,
        width: '35%',
        isEditable: false
    },
    {
        _key: 'version',
        label: getMultiTermText({ id: '3001657', text: 'Version' }),
        searching: true,
        sorting: true,
        width: '35%',
        isEditable: false
    },
    {
        _key: 'enabled',
        label: getMultiTermText({ id: '99000784', text: 'Enabled' }),
        searching: true,
        sorting: true,
        width: '20%',
        isEditable: false
    },
];
